const cliente = (DataBase, Datatype) => {
	const Cliente = DataBase.new(
		{
			nome: Datatype.STRING,
			id_municipio: Datatype.NUMBER,
			id_estado: Datatype.NUMBER,
			cpf_cnpj: Datatype.STRING,
			cep: Datatype.STRING,
			endereco: Datatype.STRING,
			endereco_ref: Datatype.STRING,
			fone: Datatype.STRING,
			dt_nascimento: Datatype.TIMESTAMP,
			email: Datatype.STRING,
			estado_civil: Datatype.NUMBER,
			filhos: Datatype.BOOLEAN,
			sexo: Datatype.BOOLEAN,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "cliente",
			model: "Cliente",
		}
	);

	Cliente.assume = (models) => [
		{
			model: models.Pedido,
			name: "pedidos",
		},
		{
			model: models.ClienteAnotacao,
			name: "anotacoes",
		},
	];

	return Cliente;
};

export default cliente;
